@if (recurring() && recurring()?.isActive) {
  <div
    class="c-recurring"
    #recurringTrigger
    [class.c-recurring__blocked]="isRecurringLocked()"
    theming
    themingGroup="progressline"
    avoidMulticlick
    tabindex="0"
    role="button"
    (safeClick)="redeemRecurring()"
    (keydown.enter)="recurringTrigger.click()"
    [themingAsset]="!isReadyToCollect() || isRecurringLocked() ? 'sachet-background-off' : 'sachet-background-on'">
    <div
      class="e-icon"
      theming
      themingGroup="progressline"
      [themingAsset]="isReadyToCollect() && !isRecurringLocked() ? 'sachet-gif' : 'sachet-off'"></div>

    <div class="e-context">
      @if (!isRecurringLocked()) {
        <span>{{ 'home.recurring.title' | translate }}</span>
      }

      @if (recurring() && !isRecurringLocked()) {
        <slotcom-display [classes]="['c-display--wallet']">
          <div
            displayIcon
            displayIconPos="left"
            [class]="'c-display--coin'"></div>
          <span
            data-testid="recurring-reward"
            [style.font-size]="fontSize()"
            >{{ recurring()?.nextBonus | number: '1.0-0' : ('common.culture' | translate) }}</span
          >
        </slotcom-display>
      }

      @if (isRecurringLocked()) {
        <span>{{ 'home.recurring.blocked' | translate }}</span>
      } @else {
        @if (isReadyToCollect()) {
          <span>{{ 'home.recurring.subtitle' | translate | uppercase }}</span>
        } @else {
          <slotcom-animated-timer
            [showIcon]="true"
            [showInDays]="true"
            [endDate]="recurring()?.remaining"
            (expired)="onExpiredRecurring()"></slotcom-animated-timer>
        }
      }
    </div>
  </div>
  @if (isRecurringLocked()) {
    <div
      class="c-recurring__lock__icon"
      theming
      themingGroup="none"
      themingAsset="lock"></div>
  }
}
